module.exports = __webpack_public_path__ + "media/images/views/home/step/step-1-d66476eb1b1863b26557e229ac540549.png";